'use client';

import React from 'react';
import { Condition } from '@skin-seoul/utils';
import ProductCardSkeleton from './ProductCard.Skeleton';
import type { ProductCardProps } from '@skin-seoul/shared-components';
import { HorizontalProductCard, VerticalProductCard } from '@skin-seoul/shared-components';
import { SafeLink } from '@/components/ui/SafeLink';
const ProductCard = ({
  theme = 'light',
  onClick,
  orientation = 'vertical',
  ...props
}: ProductCardProps & {
  orientation?: 'vertical' | 'horizontal';
}) => {
  return <Condition expression={orientation === 'vertical'} then={<VerticalProductCard onClick={onClick} {...props} theme={theme} linkComponent={SafeLink}>
          <VerticalProductCard.Image bottomSlot={<VerticalProductCard.AddToCart mx={{
      base: 1,
      tablet: 2
    }} marginBottom={{
      base: 1,
      tablet: 2
    }} />} />
          <VerticalProductCard.Content>
            <VerticalProductCard.InfoName />
            <VerticalProductCard.InfoPrice />
            <VerticalProductCard.InfoRating />
          </VerticalProductCard.Content>
        </VerticalProductCard>} else={<HorizontalProductCard onClick={onClick} {...props} theme={theme} linkComponent={SafeLink}>
          <HorizontalProductCard.Image />
          <HorizontalProductCard.Content bottomSlot={<HorizontalProductCard.AddToCart />}>
            <HorizontalProductCard.InfoName />
            <HorizontalProductCard.InfoPrice />
            <HorizontalProductCard.InfoRating />
          </HorizontalProductCard.Content>
        </HorizontalProductCard>} data-sentry-element="Condition" data-sentry-component="ProductCard" data-sentry-source-file="ProductCard.tsx" />;
};
ProductCard.Skeleton = ProductCardSkeleton;
export default ProductCard;